import {
  MachineModelType,
  ModelStatus,
} from 'lib_ts/enums/machine-models.enums';
import { BallType } from 'lib_ts/enums/machine.enums';

export enum MachineModelsDialog {
  DialogArchive = 'DialogArchive',
  DialogCopy = 'DialogCopy',
  DialogCreate = 'DialogCreate',
  DialogEditor = 'DialogEditor',
  DialogPerformance = 'DialogPerformance',
}

export interface MachineModelsFilters {
  statuses: ModelStatus[];
  ballTypes: BallType[];
  types: MachineModelType[];
  machines: string[];
  names: string[];
  created: string[];
  hasInvestigationNotes?: boolean;
}
